import {useMemo} from "react";
import DoubleArcGauge from "../../../../components/echarts/double-arc-gauge.jsx";
import {translatedKeys} from "../utils/translated-keys.js";

const FALLBACK_KEYS = ["Administração", "Patrulhamento", "Posto fixo", ""];

const DutyIntendedFunction = ({data, className = "", height = "100%", garrisons}) => {
    const items = useMemo(() => {
        const entries = Object.entries(data ?? {}).slice(0, 4);
        const presentKeys = new Set(entries.map(([key]) => key));

        for (const key of FALLBACK_KEYS) {
            if (entries.length >= 4) break;
            if (!presentKeys.has(key)) entries.push([key, 0]);
        }

        return entries.map(([key, value]) => ({
            key: key || "not-informed",
            label: translatedKeys[key] || key || "Não informado",
            value: Number(value) || 0,
        }));
    }, [data]);

    return (
        <section
            className={["flex min-h-0 flex-col", className].filter(Boolean).join(" ")}
            style={{height}}
        >
            <h3 className="mb-1.5! shrink-0 text-center text-(length:--font-md)! text-[#AAAAAA]">
                Função destinada
            </h3>

            <div className="grid min-h-0 flex-1 grid-cols-2 grid-rows-2 gap-(--dash-gap-sm)">
                {items.map((item) => (
                    <DoubleArcGauge
                        key={item.key}
                        value={item.value}
                        max={garrisons}
                        label={item.label}
                        className="min-h-0 min-w-0"
                    />
                ))}
            </div>
        </section>
    );
};

export default DutyIntendedFunction;
